module.exports = __webpack_public_path__ + "ce6ec0873a3886e696cf8b5ef4d30c7c.jpg";